































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class PageFooter extends Vue {
  get wpUrl() {
    return process.env.VUE_APP_WORDPRESS_URL;
  }
}
